module.exports = __webpack_public_path__ + "static/img/ni.03b82d30.jpg";